import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import CTA, { isValidCta } from 'components/shared/CTA/CTA';
import MIcon from '../../public/icons/m-icon.svg';
import { FeaturedJobsProps } from 'libs/contentful/props';
import { getSectionProps } from 'utils/styles';
import { liveUpdateAttrs } from 'libs/contentful/utils';

export const FeaturedJobs = ({ sys, sectionName, headline, copy, cta, margins, color }: FeaturedJobsProps) => {
  return (
    <section {...getSectionProps(color, margins, sectionName)}>
      <div className="content-wrapper flex flex-col md:flex-row md:justify-between gap-6 md:gap-18">
        <div className="relative md:min-h-[675px]">
          {headline && (
            <div
              className="md:max-w-[375px] font-sans font-semibold text-heading-md sm:text-heading-lg md:text-heading-xxl mb-6"
              {...liveUpdateAttrs(sys?.id, 'headline')}>
              <RichTextHeadline headline={headline} />
            </div>
          )}
          {copy && (
            <div
              className="sm:max-w-[640px] md:max-w-[525px] font-serif text-body-serif"
              {...liveUpdateAttrs(sys?.id, 'copy')}>
              <RichTextCopy copy={copy} />
            </div>
          )}
          {cta && isValidCta(cta) && (
            <div className="hidden sm:inline-block mt-10" {...liveUpdateAttrs(sys?.id, 'cta')}>
              <CTA cta={cta} />
            </div>
          )}
          <div className="hidden md:block w-[400px] absolute -bottom-20 -left-10">
            <MIcon className="w-full" />
          </div>
        </div>
        <div className="flex flex-col gap-6 md:flex-auto">
          <div className="w-full p-6 md:p-10 rounded-2xl">
            <p>job item</p>
          </div>
          {cta && isValidCta(cta) && (
            <div className="sm:hidden mt-6" {...liveUpdateAttrs(sys?.id, 'cta')}>
              <CTA cta={cta} />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default FeaturedJobs;
